import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaMagnifyingGlass } from "react-icons/fa6";
import AttendanceOverview from "./index";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_LEAVE } from "variables/constants";

const attendanceRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Overview",
		basePath: "overview",
		mainComponent: <AttendanceOverview />,
	    layout: "/console",	   
	    icon: <FaMagnifyingGlass className="icon-item" />,
	    subTitle:"Overview",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:5,
		moduleId: MODULE_LEAVE,
	})
]

export default attendanceRoutes;